module.exports = __webpack_public_path__ + "img/strata-festival-blindspot.bf234d69.jpeg";